import React from 'react';

const COLOR_MAP = {
  gray:   'border-gray-400 bg-gray-50 text-gray-700',
  yellow: 'border-yellow-400 bg-yellow-50 text-yellow-800',
  orange: 'border-orange-400 bg-orange-50 text-orange-800',
  red:    'border-red-500 bg-red-50 text-red-700',
  green:  'border-emerald-500 bg-emerald-50 text-emerald-700',
  blue:   'border-blue-500 bg-blue-50 text-blue-700',
};

const Opciones = ({ pregunta, answer, onAnswer }) => {
  const { opciones = [] } = pregunta;
  const selectedId = answer?.selectedId || null;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
      {opciones.map(opcion => {
        const isSelected = selectedId === opcion.id;
        const colorCls = isSelected
          ? (COLOR_MAP[opcion.color] || COLOR_MAP.red)
          : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50';

        return (
          <button
            key={opcion.id}
            type="button"
            onClick={() => onAnswer({ selectedId: opcion.id, valor: opcion.valor ?? opcion.id })}
            className={`flex items-center gap-2.5 px-4 py-2.5 rounded-xl border-2 text-left transition-all flex-1 sm:flex-none sm:min-w-[160px] ${colorCls}`}
          >
            {opcion.emoji && (
              <span className="text-xl leading-none flex-shrink-0">{opcion.emoji}</span>
            )}
            <div className="min-w-0">
              <p className="text-sm font-bold leading-tight">{opcion.label}</p>
              {opcion.desc && (
                <p className="text-xs font-normal opacity-75 mt-0.5 leading-tight">{opcion.desc}</p>
              )}
            </div>
            {isSelected && (
              <span className="ml-auto flex-shrink-0 text-xs font-bold">✓</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Opciones;
